import React from 'react';
import { ProFormSelect } from '@ant-design/pro-form';
import { useQuery, gql } from '@apollo/client';
import { Space, Typography } from 'antd';
import CurrencyDisplay from '../../layout/CurrencyDisplay';

const { Text } = Typography;

const GET_BUDGETS = gql`
  query selectBudget($ids: [ID!], $projectIds: [ID!]) {
    budgets(ids: $ids, projectIds: $projectIds) {
      id
      balance
      budgetCategory {
        id
        name
      }
    }
  }
`;

const SelectBudget = ({ projectId, ...props }) => {
  const { data, loading } = useQuery(GET_BUDGETS, {
    variables: { projectIds: [projectId] },
  });
  const options = loading
    ? []
    : data.budgets.map(({ id, balance, budgetCategory }) => ({
        value: id,
        label: budgetCategory.name,
        balance,
      }));
  return (
    <ProFormSelect
      width="xl"
      options={options}
      fieldProps={{
        optionItemRender(item) {
          return (
            <Space direction="vertical">
              {item.label}
              <Text type="secondary">
                current balance: <CurrencyDisplay amount={item.balance} />
              </Text>
            </Space>
          );
        },
      }}
      rules={[
        {
          required: true,
          message: 'Please select from budget!',
        },
      ]}
      {...props}
    />
  );
};

export default SelectBudget;
